import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientConvention, ConventionData } from '../../../../../models/formation/convention.models';
import { StageService } from '../../services/stage-modal.service';
import { ConventionService } from '../convention.service';

@Component({
  selector: 'queoval-client-convention',
  templateUrl: './client-convention.component.html',
  styleUrls: ['./client-convention.component.css', '../convention.component.css']
})

export class ClientConventionComponent {

  @Input() client: ClientConvention;
  @Input('index') i: number;

  constructor(
    private conventionService: ConventionService,
    private stageService: StageService,
  ) { }

  /**
   * récupération des données du client sélectionné
   * @param pClient
   */
  public OnSelectClient(pClient: ClientConvention): Observable<[ConventionData, ClientConvention]> {
    return this.conventionService.OnSelectClient(pClient, this.stageService.Stage.Ident);
  }

  /** Ajout d'une instance du modèle de nouvelle convention propre au client sélectionné dans la liste des conventions */
  public AddNewConvention(pClient: ClientConvention): void {
    pClient.displayed = true;
    this.OnSelectClient(pClient).subscribe(() => {
      pClient.Conventions.unshift(JSON.parse(JSON.stringify(pClient.newConvention)));
    });
  }
}
